import { IIntba001 } from "src/components/ModalIniciatives/Iniciatives/interface";
import IBaseDTO from "src/Interfaces/baseDTO";
import { IPrtba005 } from "src/pages/Projects/Project/interface";
import { IMetbe001 } from "src/pages/StrategicPlanning/Strategies/interface";
import { IAssociations } from "../Badge/badgeAssociate";
import { IMetba002 } from "../Perspective/interface";


export interface IObjectives{
    perspective: IMetba002;
    objectives: IMetba003[];
}

export interface IModalObjective{
    onCallbackMap?: () => void;
}

export interface IRefObjectivesModals{
    openModal: (perspective: IMetba002, objective?: IMetba003) => void;
}

export interface IMetba006{
    mea006Id:number;
    mea006Cor:string;
    mea006Valorini:number;
    mea006Valorfim:number;
}

export interface IMetba003 extends IBaseDTO{
    id: string;
    mea003Id: number;
    mea003Mea002Id: number;
    mea003Mea002Nome: string;
    mea003Nome: string;
    mea003Descricao: string;
    mea003Peso: number;
    mea003Calcperc: number;
    mea003Taa001Id?: number;
    mea003Taa006Id?: number;
    intba001?: IIntba001[];
    metba004?: IMetba004[];
    metba005?: IMetba005[];
    metba006?: IMetba006[];
    prtba005?: IPrtba005[];
    metbe001?: IMetbe001[];
    metbs002?: any[];
    emphasis: boolean;
    associations: IAssociations;
    realizedPercentage: number;
    factorCriticalSuccess: boolean;
    color: string;
}

export interface IMetba004{
    mea004Id: number;
    mea004Mea003Id: number;
    mea004Iqc001Id: number;
    mea004Iqc001Nome: string;
    Mea004Iqc001Nivel: string;
    mea004Ordem: number;
    mea004FatorSucesso: string;
    mea004Peso: number;
}

export interface IMetba005{
    mea005Id: number;
    mea005Mea003Id: number;
    mea005Mea003Id2: number;
}

export interface StyledCard{
    color: string;
    emphasis: boolean;
    inEditCauseEffect: boolean;
}

export enum CalculatePercentageType {
    INDICATORS = "1",
    ACTIONS = "2",
    INDICATORS_ACTIONS = "3",
    PROJECTS = "4",
    INDICATORS_PROJECTS = "5",
    PROJECTS_ACTIONS = "6",
    INDICATORS_PROJECTS_ACTIONS = "7"
}
